import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Controller, Scene } from "react-scrollmagic";
import { useSpring, animated, config } from "@react-spring/web";

import { down, size_down } from "~/src/config/vars";

import kaktus from "../../images/banner/kaktus.svg";
import kofe from "../../images/banner/kofe2.svg";
import camera from "../../images/banner/camera.svg";
import test from "../../images/banner/test.svg";
import girl from "../../images/banner/girl.svg";

const BlockAboutBanner = () => {
    const only_mobile = size_down("md");
    const [progress, setProgress] = useState(null);
    const [isMobile, setIsMobile] = useState(false);

    // const progress = 0;

    const a_girl = useSpring({
        config: { duration: 300, ...config.wobbly },
        delay: 100,
        // opacity: progress >= 0.5 ? 1 : 0,
        y: progress >= 0.5 ? `0%` : `100%`,
        x: `-50%`,
        from: {
            // opacity: 0,
            y: `100%`,
            x: `-50%`,
        },
    });

    const a_kaktus1 = useSpring({
        config: { duration: 200, ...config.gentle },
        delay: 0,
        rotate: progress >= 0.5 ? -31 : 31,
        opacity: progress >= 0.5 ? 1 : 0.1,
        filter: progress >= 0.5 ? `grayscale(0)` : `grayscale(1)`,
        from: {
            opacity: 0.1,
            rotate: 31,
            filter: `grayscale(1)`,
        },
    });

    const a_kaktus2 = useSpring({
        config: { duration: 200, ...config.gentle },
        delay: 0,
        opacity: progress >= 0.5 ? 1 : 0,
        from: {
            opacity: 0,
        },
    });

    const a_kaktus3 = useSpring({
        config: { duration: 200, ...config.gentle },
        delay: 300,
        opacity: progress >= 0.5 ? 1 : 0.1,
        filter: progress >= 0.5 ? `grayscale(0)` : `grayscale(1)`,
        rotate: progress >= 0.5 ? -37 : 0,
        from: {
            opacity: 0.1,
            filter: `grayscale(1)`,
            rotate: 0,
        },
    });
    const a_kaktus4 = useSpring({
        config: { duration: 200, ...config.gentle },
        delay: 0,
        opacity: progress >= 0.5 ? 1 : 0,
        from: {
            opacity: 0,
        },
    });
    const a_kaktus5 = useSpring({
        config: { duration: 200, ...config.gentle },
        delay: 100,
        opacity: progress >= 0.5 ? 1 : 0,
        from: {
            opacity: 0,
        },
    });
    const a_kaktus6 = useSpring({
        config: { duration: 200, ...config.gentle },
        delay: 0,
        opacity: progress >= 0.5 ? 1 : 0,
        rotate: progress >= 0.5 ? -20 : 0,
        from: {
            opacity: 0,
            rotate: 0,
        },
    });
    const a_kaktus7 = useSpring({
        config: { duration: 200, ...config.gentle },
        delay: 200,
        opacity: progress >= 0.5 ? 1 : 0,
        rotate: progress >= 0.5 ? 35 : 0,
        from: {
            opacity: 0,
            rotate: 0,
        },
    });
    const a_kaktus8 = useSpring({
        config: { duration: 200, ...config.gentle },
        delay: 150,
        opacity: progress >= 0.5 ? 1 : 0,
        from: {
            opacity: 0,
        },
    });
    const a_camera1 = useSpring({
        config: { duration: 200, ...config.gentle },
        delay: 50,
        opacity: progress >= 0.5 ? 1 : 0,
        from: {
            opacity: 0,
        },
    });
    const a_camera2 = useSpring({
        config: { duration: 200, ...config.gentle },
        delay: 300,
        rotate: progress >= 0.5 ? 34 : 0,
        opacity: progress >= 0.5 ? 1 : 0.1,
        filter: progress >= 0.5 ? `grayscale(0)` : `grayscale(1)`,
        from: {
            rotate: 0,
            opacity: 0.1,
            filter: `grayscale(1)`,
        },
    });
    const a_camera3 = useSpring({
        config: { duration: 200, ...config.gentle },
        delay: 200,
        opacity: progress >= 0.5 ? 1 : 0,
        rotate: progress >= 0.5 ? -119 : 0,
        from: {
            opacity: 0,
            rotate: 0,
        },
    });
    const a_camera4 = useSpring({
        config: { duration: 200, ...config.gentle },
        delay: 100,
        opacity: progress >= 0.5 ? 1 : 0,
        rotate: progress >= 0.5 ? -27 : 0,
        from: {
            opacity: 0,
            rotate: 0,
        },
    });
    const a_camera5 = useSpring({
        config: { duration: 200, ...config.gentle },
        delay: 0,
        rotate: progress >= 0.5 ? -14 : 0,
        opacity: progress >= 0.5 ? 1 : 0.1,
        filter: progress >= 0.5 ? `grayscale(0)` : `grayscale(1)`,
        scaleX: -1,
        from: {
            rotate: 0,
            opacity: 0.1,
            filter: `grayscale(1)`,
            scaleX: -1,
        },
    });
    const a_camera6 = useSpring({
        config: { duration: 200, ...config.gentle },
        delay: 200,
        opacity: progress >= 0.5 ? 1 : 0,
        scaleX: -1,
        from: {
            opacity: 0,
            scaleX: -1,
        },
    });
    const a_camera7 = useSpring({
        config: { duration: 200, ...config.gentle },
        delay: 0,
        opacity: progress >= 0.5 ? 1 : 0.1,
        rotate: progress >= 0.5 ? 32 : 0,
        filter: progress >= 0.5 ? `grayscale(0)` : `grayscale(1)`,
        from: {
            opacity: 0.1,
            filter: `grayscale(1)`,
            rotate: 0,
        },
    });
    const a_camera8 = useSpring({
        config: { duration: 200, ...config.gentle },
        delay: 400,
        rotate: progress >= 0.5 ? -12 : 0,
        opacity: progress >= 0.5 ? 1 : 0.1,
        filter: progress >= 0.5 ? `grayscale(0)` : `grayscale(1)`,
        scaleX: -1,
        from: {
            rotate: 0,
            opacity: 0.1,
            filter: `grayscale(1)`,
            scaleX: -1,
        },
    });
    const a_camera9 = useSpring({
        config: { duration: 200, ...config.gentle },
        delay: 0,
        opacity: progress >= 0.5 ? 1 : 0,
        from: {
            opacity: 0,
        },
    });

    const a_kofe1 = useSpring({
        config: { duration: 200, ...config.gentle },
        delay: 300,
        opacity: progress >= 0.5 ? 1 : 0.1,
        rotate: progress >= 0.5 ? 22 : 0,
        filter: progress >= 0.5 ? `grayscale(0)` : `grayscale(1)`,
        from: {
            opacity: 0.1,
            rotate: 0,
            filter: `grayscale(1)`,
        },
    });
    const a_kofe2 = useSpring({
        config: { duration: 200, ...config.gentle },
        delay: 0,
        opacity: progress >= 0.5 ? 1 : 0,
        rotate: progress >= 0.5 ? -14 : 0,
        from: {
            opacity: 0,
            rotate: 0,
        },
    });
    const a_kofe3 = useSpring({
        config: { duration: 200, ...config.gentle },
        delay: 150,
        opacity: progress >= 0.5 ? 1 : 0.1,
        rotate: progress >= 0.5 ? 33 : 0,
        filter: progress >= 0.5 ? `grayscale(0)` : `grayscale(1)`,
        from: {
            opacity: 0.1,
            rotate: 0,
            filter: `grayscale(1)`,
        },
    });
    const a_kofe4 = useSpring({
        config: { duration: 200, ...config.gentle },
        delay: 50,
        opacity: progress >= 0.5 ? 1 : 0,
        scaleX: -1,
        from: {
            opacity: 0,
            scaleX: -1,
        },
    });
    const a_kofe5 = useSpring({
        config: { duration: 200, ...config.gentle },
        delay: 500,
        opacity: progress >= 0.5 ? 1 : 0,
        scaleX: -1,
        from: {
            opacity: 0,
            scaleX: -1,
        },
    });
    const a_kofe6 = useSpring({
        config: { duration: 200, ...config.gentle },
        delay: 200,
        opacity: progress >= 0.5 ? 1 : 0.1,
        filter: progress >= 0.5 ? `grayscale(0)` : `grayscale(1)`,
        rotate: progress >= 0.5 ? 0 : -15,
        scaleX: -1,
        from: {
            opacity: 0.1,
            filter: `grayscale(1)`,
            scaleX: -1,
            rotate: -15,
        },
    });

    const a_test1 = useSpring({
        config: { duration: 200, ...config.gentle },
        delay: 100,
        opacity: progress >= 0.5 ? 1 : 0,
        rotate: progress >= 0.5 ? -15 : 0,
        from: {
            opacity: 0,
            rotate: 0,
        },
    });
    const a_test2 = useSpring({
        config: { duration: 200, ...config.gentle },
        delay: 0,
        rotate: progress >= 0.5 ? 77 : 0,
        opacity: progress >= 0.5 ? 1 : 0.1,
        filter: progress >= 0.5 ? `grayscale(0)` : `grayscale(1)`,
        from: {
            rotate: 0,
            opacity: 0.1,
            filter: `grayscale(1)`,
        },
    });
    const a_test3 = useSpring({
        config: { duration: 200, ...config.gentle },
        delay: 300,
        opacity: progress >= 0.5 ? 1 : 0,
        rotate: progress >= 0.5 ? 2 : 0,
        from: {
            opacity: 0,
            rotate: 0,
        },
    });
    const a_test4 = useSpring({
        config: { duration: 200, ...config.gentle },
        delay: 100,
        opacity: progress >= 0.5 ? 1 : 0,
        rotate: progress >= 0.5 ? -15 : 0,
        from: {
            opacity: 0,
            rotate: 0,
        },
    });
    const a_test5 = useSpring({
        config: { duration: 200, ...config.gentle },
        delay: 0,
        opacity: progress >= 0.5 ? 1 : 0,
        rotate: progress >= 0.5 ? -13 : 0,
        from: {
            opacity: 0,
            rotate: 0,
        },
    });
    const a_test6 = useSpring({
        config: { duration: 200, ...config.gentle },
        delay: 200,
        opacity: progress >= 0.5 ? 1 : 0,
        from: {
            opacity: 0,
        },
    });

    useEffect(() => {
        if (only_mobile) {
            setIsMobile(true);
        } else {
            setIsMobile(false);
        }
    }, [only_mobile]);

    return (
        <SBlockAboutBanner>
            <Controller refreshInterval={1}>
                <Scene duration="100%" offset={isMobile ? "-300vw" : "-500vw"}>
                    {(progress) => {
                        setTimeout(() => setProgress(progress), 0);
                        return <div></div>;
                    }}
                </Scene>
            </Controller>
            <animated.img
                style={a_kaktus1}
                src={kaktus}
                alt="kaktus"
                className="kaktus1"
            />
            <animated.img
                style={a_kaktus2}
                src={kaktus}
                alt="kaktus"
                className="kaktus2"
            />
            <animated.img
                style={a_kaktus3}
                src={kaktus}
                alt="kaktus"
                className="kaktus3"
            />
            <animated.img
                style={a_kaktus4}
                src={kaktus}
                alt="kaktus"
                className="kaktus4"
            />
            <animated.img
                style={a_kaktus5}
                src={kaktus}
                alt="kaktus"
                className="kaktus5"
            />
            <animated.img
                style={a_kaktus6}
                src={kaktus}
                alt="kaktus"
                className="kaktus6"
            />
            <animated.img
                style={a_kaktus7}
                src={kaktus}
                alt="kaktus"
                className="kaktus7"
            />
            <animated.img
                style={a_kaktus8}
                src={kaktus}
                alt="kaktus"
                className="kaktus8"
            />
            <animated.img
                style={a_camera1}
                src={camera}
                alt="camera"
                className="camera1"
            />
            <animated.img
                style={a_camera2}
                src={camera}
                alt="camera"
                className="camera2"
            />
            <animated.img
                style={a_camera3}
                src={camera}
                alt="camera"
                className="camera3"
            />
            <animated.img
                style={a_camera4}
                src={camera}
                alt="camera"
                className="camera4"
            />
            <animated.img
                style={a_camera5}
                src={camera}
                alt="camera"
                className="camera5"
            />
            <animated.img
                style={a_camera6}
                src={camera}
                alt="camera"
                className="camera6"
            />
            <animated.img
                style={a_camera7}
                src={camera}
                alt="camera"
                className="camera7"
            />
            <animated.img
                style={a_camera8}
                src={camera}
                alt="camera"
                className="camera8"
            />
            <animated.img
                style={a_camera9}
                src={camera}
                alt="camera"
                className="camera9"
            />

            <animated.img
                style={a_kofe1}
                src={kofe}
                alt="kofe"
                className="kofe1"
            />
            <animated.img
                style={a_kofe2}
                src={kofe}
                alt="kofe"
                className="kofe2"
            />
            <animated.img
                style={a_kofe3}
                src={kofe}
                alt="kofe"
                className="kofe3"
            />
            <animated.img
                style={a_kofe4}
                src={kofe}
                alt="kofe"
                className="kofe4"
            />
            <animated.img
                style={a_kofe5}
                src={kofe}
                alt="kofe"
                className="kofe5"
            />
            <animated.img
                style={a_kofe6}
                src={kofe}
                alt="kofe"
                className="kofe6"
            />

            <animated.img
                style={a_test1}
                src={test}
                alt="test"
                className="test1"
            />
            <animated.img
                style={a_test2}
                src={test}
                alt="test"
                className="test2"
            />
            <animated.img
                style={a_test3}
                src={test}
                alt="test"
                className="test3"
            />
            <animated.img
                style={a_test4}
                src={test}
                alt="test"
                className="test4"
            />
            <animated.img
                style={a_test5}
                src={test}
                alt="test"
                className="test5"
            />
            <animated.img
                style={a_test6}
                src={test}
                alt="test"
                className="test6"
            />

            <animated.div style={a_girl} className="girl">
                <img src={girl} alt={girl} />
            </animated.div>
        </SBlockAboutBanner>
    );
};

const SBlockAboutBanner = styled.div`
    position: relative;
    overflow: hidden;
    background-color: #f4f6ff;
    height: 40vw;
    ${down("sm")} {
        height: 80vw;
    }
    img {
        position: absolute;
    }
    .girl {
        position: absolute;
        left: 50%;
        bottom: -10px;
        transform: translateY(0) translateX(-50%);
        img {
            width: 28vw;
            display: block;
            position: static;
            ${down("sm")} {
                width: 50vw;
            }
        }
    }
    .kaktus1 {
        width: 8.9vw;
        left: 3vw;
        top: 2.5vw;
        transform: rotate(-31deg);
        ${down("sm")} {
            top: 12.5vw;
        }
    }
    .kaktus2 {
        width: 7.3vw;
        left: -2.7vw;
        top: 27.9vw;
        transform: rotate(49deg);
        ${down("sm")} {
        }
    }
    .kaktus3 {
        width: 10vw;
        left: 37.3vw;
        top: 3.9vw;
        transform: rotate(-37deg);
        ${down("sm")} {
            top: 9.9vw;
        }
    }
    .kaktus4 {
        width: 7.4vw;
        left: 30.4vw;
        bottom: -4.4vw;
        transform: rotate(48deg);
        ${down("sm")} {
        }
    }
    .kaktus5 {
        width: 10.4vw;
        right: -4.4vw;
        bottom: -7vw;
        transform: rotate(24deg);
        ${down("sm")} {
        }
    }
    .kaktus6 {
        width: 11vw;
        right: 16.4vw;
        top: -10.4vw;
        transform: rotate(-20deg);
        ${down("sm")} {
            top: -2.4vw;
        }
    }
    .kaktus7 {
        width: 10vw;
        right: 19.4vw;
        top: 13.6vw;
        transform: rotate(35deg);
        ${down("sm")} {
            top: 27.6vw;
        }
    }
    .kaktus8 {
        width: 7vw;
        left: 30vw;
        top: -7.8vw;
        transform: rotate(26deg);
        ${down("sm")} {
        }
    }
    .camera1 {
        width: 9vw;
        left: 2vw;
        top: -5.8vw;
        transform: rotate(2deg);
        ${down("sm")} {
        }
    }
    .camera2 {
        width: 8vw;
        left: 22.7vw;
        top: 4vw;
        transform: rotate(34deg);
        ${down("sm")} {
            top: 14vw;
        }
    }
    .camera3 {
        width: 8.4vw;
        left: 37.2vw;
        top: -1.3vw;
        transform: rotate(-119deg);
        ${down("sm")} {
        }
    }
    .camera4 {
        width: 8vw;
        left: -1vw;
        bottom: 13.7vw;
        transform: rotate(-27deg);
        ${down("sm")} {
        }
    }
    .camera5 {
        width: 11vw;
        left: 22.44vw;
        bottom: 5.3vw;
        transform: rotate(-14deg) scaleX(-1);
        ${down("sm")} {
        }
    }
    .camera6 {
        width: 11vw;
        left: 2vw;
        bottom: -5.7vw;
        transform: rotate(-60deg) scaleX(-1);
        ${down("sm")} {
        }
    }
    .camera7 {
        width: 11vw;
        right: 26vw;
        top: 7vw;
        transform: rotate(32deg);
        ${down("sm")} {
            top: 14vw;
        }
    }
    .camera8 {
        width: 11vw;
        right: 4vw;
        top: 6.9vw;
        transform: rotate(-12deg) scaleX(-1);
        ${down("sm")} {
            top: 22.9vw;
        }
    }
    .camera9 {
        width: 11.3vw;
        right: 22.4vw;
        bottom: -1vw;
        transform: rotate(-2deg);
        ${down("sm")} {
        }
    }
    .kofe1 {
        width: 9vw;
        right: 10.4vw;
        bottom: 5.6vw;
        transform: rotate(22deg);
        ${down("sm")} {
            bottom: 14.6vw;
        }
    }
    .kofe2 {
        width: 6.3vw;
        left: 27.4vw;
        bottom: 16.4vw;
        transform: rotate(-14deg);
        ${down("sm")} {
        }
    }
    .kofe3 {
        width: 9.2vw;
        top: -1.6vw;
        left: 12vw;
        transform: rotate(33deg);
        ${down("sm")} {
        }
    }
    .kofe4 {
        width: 8.7vw;
        left: 13.8vw;
        bottom: -1.8vw;
        transform: rotate(-31deg) scaleX(-1);
        ${down("sm")} {
            bottom: 12.2vw;
        }
    }
    .kofe5 {
        width: 9.3vw;
        right: -6.5vw;
        top: -0.5vw;
        transform: rotate(-53deg) scaleX(-1);
        ${down("sm")} {
            top: 5.5vw;
        }
    }
    .kofe6 {
        width: 9.3vw;
        right: 39.5vw;
        top: 20.5vw;
        transform: rotate(-53deg) scaleX(-1);
        ${down("sm")} {
            top: 40.5vw;
        }
    }

    .test1 {
        width: 10.4vw;
        left: 15.2vw;
        top: 10.7vw;
        transform: rotate(-15deg);
        ${down("sm")} {
            top: 24.7vw;
        }
    }
    .test2 {
        width: 6.3vw;
        left: 7.1vw;
        top: 23.5vw;
        transform: rotate(77deg);
        ${down("sm")} {
            top: 43.5vw;
        }
    }
    .test3 {
        width: 6.4vw;
        left: 56.7vw;
        top: -2.3vw;
        transform: rotate(2deg);
        ${down("sm")} {
            top: 3.7vw;
        }
    }
    .test4 {
        width: 8.7vw;
        right: 5.6vw;
        top: -8.3vw;
        transform: rotate(-15deg);
        ${down("sm")} {
        }
    }
    .test5 {
        width: 8.4vw;
        right: -2.4vw;
        top: 16vw;
        transform: rotate(-13deg);
        ${down("sm")} {
            top: 36vw;
        }
    }
    .test6 {
        width: 6.4vw;
        right: 10.2vw;
        bottom: -3.6vw;
        transform: rotate(-25deg);
        ${down("sm")} {
            bottom: 0.4vw;
        }
    }
`;

export default BlockAboutBanner;
